export const filterEmpty = facets => {
  return facets.reduce((acc, facet) => {
    const { config, values, groups } = facet;
    if (!config) return acc;
    if (!values || groups) {
      acc.push(facet);
      return acc;
    }

    const { hideWhenAllValuesEmpty, excludeZeroCount, itemsToShow } = config;

    const filteredValues = values.filter(item => {
      if (!item) return false;
      const matchItems = !itemsToShow || itemsToShow.includes(item.name);
      const notZero = !excludeZeroCount || item.count !== 0 || item.selected;
      return matchItems && notZero;
    });

    if (!filteredValues.length) return acc;

    if (hideWhenAllValuesEmpty && !filteredValues.some(v => v.count !== 0 || v.selected)) {
      return acc;
    }

    acc.push({ ...facet, values: filteredValues });
    return acc;
  }, []);
};
